const { Box } = require('@mui/material');
const { useEffect, useState } = require('react');
const { default: ReactQuill } = require('react-quill-new');
const { normalizeReactQuillHtml } = require('../../../utils/reactQuillHtmlNormalizer');

/**
 * RichTextEditorCell
 * - Controlled per-cell editor
 * - Calls params.api.setEditCellValue (so the grid knows), AND
 * - Calls onInternalEditChange to update our local rows state immediately (so Save will have latest value)
 */
export const RichTextEditorCell = ({ params, onInternalEditChange }) => {
  const [value, setValue] = useState(params.value || '');

  useEffect(() => {
    setValue(params.value || '');
  }, [params.value]);

  const handleChange = val => {
    // update editor
    setValue(val);
    // update DataGrid edit buffer
    if (params?.api?.setEditCellValue) {
      params.api.setEditCellValue({
        id: params.id,
        field: params.field,
        value: val,
      });
    }

    if (typeof onInternalEditChange === 'function') {
      onInternalEditChange(params.id, params.field, val);
    }
  };

  const handleBlur = (_range, _source, editor) => {
    const html = editor?.getHTML ? editor.getHTML() : value;
    const normalizedValue = normalizeReactQuillHtml(html);

    if (normalizedValue === value) return;

    setValue(normalizedValue);
    if (params?.api?.setEditCellValue) {
      params.api.setEditCellValue({
        id: params.id,
        field: params.field,
        value: normalizedValue,
      });
    }
    if (typeof onInternalEditChange === 'function') {
      onInternalEditChange(params.id, params.field, normalizedValue);
    }
  };

  return (
    <Box sx={{ width: '100%', p: 1 }}>
      <ReactQuill
        theme='snow'
        modules={{
          toolbar: [['bold', 'italic', 'underline', 'link']],
          keyboard: {
            bindings: {
              enter: {
                key: 13,
                handler: () => {
                  return true;
                },
              },
            },
          },
        }}
        formats={['bold', 'italic', 'underline', 'link']}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </Box>
  );
};
